<section id="wrapper" class="error-page">
    <div class="row">
        <div class="col-lg-6 pl-5 pr-5 error_img">
            <img src="assets/images/401.png" width="600" alt="" class="img-fluid">
        </div>
        <div class="col-lg-4 mt-auto mb-auto mobile-marg">
            <div class="error-body">
                <h2 class="text-uppercase">Information !</h2>
                <h2 class="text-uppercase">You Sesion is Logout !</h2>
                <p class="m-t-30 m-b-30 error-text">Please close the window browser and reopen the app.
                </p>
            </div>
        </div>
        <div class="col-lg-12">
            <p class="text-center mb-0">
                <img src="assets/images/logo_black_letters.png" width="100" alt="">
            </p>
        </div>
    </div>
</section>